"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.join");

require("core-js/modules/es.array.slice");

require("core-js/modules/es.date.to-string");

require("core-js/modules/es.object.create");

require("core-js/modules/es.object.define-property");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.set-prototype-of");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.parse-float");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _native = _interopRequireDefault(require("@emotion/native"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactNative = require("react-native");

var _reactNativeModalDatetimePicker = _interopRequireDefault(require("react-native-modal-datetime-picker"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Touchable =
/*#__PURE__*/
_native["default"].TouchableOpacity(function (_ref) {
  var theme = _ref.theme;
  return {
    borderColor: theme.borderColor,
    borderWidth: 1,
    borderRadius: 2,
    padding: 5
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy90eXBlcy9EYXRlLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU1rQiIsImZpbGUiOiIuLi8uLi9zcmMvdHlwZXMvRGF0ZS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBQcm9wVHlwZXMgZnJvbSAncHJvcC10eXBlcyc7XG5pbXBvcnQgUmVhY3QsIHsgUHVyZUNvbXBvbmVudCB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IFZpZXcgfSBmcm9tICdyZWFjdC1uYXRpdmUnO1xuaW1wb3J0IERhdGVUaW1lUGlja2VyIGZyb20gJ3JlYWN0LW5hdGl2ZS1tb2RhbC1kYXRldGltZS1waWNrZXInO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9uYXRpdmUnO1xuXG5jb25zdCBUb3VjaGFibGUgPSBzdHlsZWQuVG91Y2hhYmxlT3BhY2l0eSgoeyB0aGVtZSB9KSA9PiAoe1xuICBib3JkZXJDb2xvcjogdGhlbWUuYm9yZGVyQ29sb3IsXG4gIGJvcmRlcldpZHRoOiAxLFxuICBib3JkZXJSYWRpdXM6IDIsXG4gIHBhZGRpbmc6IDUsXG59KSk7XG5cbmNvbnN0IExhYmVsID0gc3R5bGVkLlRleHQoKHsgdGhlbWUgfSkgPT4gKHtcbiAgZm9udFNpemU6IDEzLFxuICBjb2xvcjogdGhlbWUubGFiZWxDb2xvcixcbn0pKTtcblxuLy8gVE9ETyBzZWNvbmRzIHN1cHBvcnRcbmNsYXNzIERhdGVUeXBlIGV4dGVuZHMgUHVyZUNvbXBvbmVudCB7XG4gIGNvbnN0cnVjdG9yKCkge1xuICAgIHN1cGVyKCk7XG4gICAgdGhpcy5zdGF0ZSA9IHtcbiAgICAgIGlzRGF0ZVZpc2libGU6IGZhbHNlLFxuICAgICAgaXNUaW1lVmlzaWJsZTogZmFsc2UsXG4gICAgfTtcbiAgfVxuXG4gIHNob3dEYXRlUGlja2VyID0gKCkgPT4ge1xuICAgIHRoaXMuc2V0U3RhdGUoeyBpc0RhdGVWaXNpYmxlOiB0cnVlIH0pO1xuICB9O1xuXG4gIHNob3dUaW1lUGlja2VyID0gKCkgPT4ge1xuICAgIHRoaXMuc2V0U3RhdGUoeyBpc1RpbWVWaXNpYmxlOiB0cnVlIH0pO1xuICB9O1xuXG4gIGhpZGVQaWNrZXIgPSAoKSA9PiB7XG4gICAgdGhpcy5zZXRTdGF0ZSh7IGlzRGF0ZVZpc2libGU6IGZhbHNlLCBpc1RpbWVWaXNpYmxlOiBmYWxzZSB9KTtcbiAgfTtcblxuICBvbkRhdGVQaWNrZWQgPSAoZGF0ZSkgPT4ge1xuICAgIGNvbnN0IHZhbHVlID0gZGF0ZS52YWx1ZU9mKCk7XG4gICAgY29uc3QgeyBvbkNoYW5nZSB9ID0gdGhpcy5wcm9wcztcbiAgICBvbkNoYW5nZSh2YWx1ZSk7XG4gICAgdGhpcy5oaWRlUGlja2VyKCk7XG4gIH07XG5cbiAgcmVuZGVyKCkge1xuICAgIGNvbnN0IHsga25vYiB9ID0gdGhpcy5wcm9wcztcblxuICAgIGNvbnN0IHsgaXNUaW1lVmlzaWJsZSwgaXNEYXRlVmlzaWJsZSB9ID0gdGhpcy5zdGF0ZTtcbiAgICBjb25zdCBkID0gbmV3IERhdGUoa25vYi52YWx1ZSk7XG5cbiAgICAvLyBodHRwczovL3N0YWNrb3ZlcmZsb3cuY29tL2EvMzAyNzI4MDNcbiAgICBjb25zdCBkYXRlU3RyaW5nID0gW1xuICAgICAgYDAke2QuZ2V0RGF0ZSgpfWAuc2xpY2UoLTIpLFxuICAgICAgYDAke2QuZ2V0TW9udGgoKSArIDF9YC5zbGljZSgtMiksXG4gICAgICBkLmdldEZ1bGxZZWFyKCksXG4gICAgXS5qb2luKCctJyk7XG4gICAgY29uc3QgdGltZVN0cmluZyA9IGAke2AwJHtkLmdldEhvdXJzKCl9YC5zbGljZSgtMil9OiR7YDAke2QuZ2V0TWludXRlcygpfWAuc2xpY2UoLTIpfWA7XG5cbiAgICByZXR1cm4gKFxuICAgICAgPFZpZXcgc3R5bGU9e3sgbWFyZ2luOiAxMCB9fT5cbiAgICAgICAgPFZpZXcgc3R5bGU9e3sgZmxleERpcmVjdGlvbjogJ3JvdycgfX0+XG4gICAgICAgICAgPFRvdWNoYWJsZSBvblByZXNzPXt0aGlzLnNob3dEYXRlUGlja2VyfT5cbiAgICAgICAgICAgIDxMYWJlbD57ZGF0ZVN0cmluZ308L0xhYmVsPlxuICAgICAgICAgIDwvVG91Y2hhYmxlPlxuICAgICAgICAgIDxUb3VjaGFibGVcbiAgICAgICAgICAgIHN0eWxlPXt7XG4gICAgICAgICAgICAgIG1hcmdpbkxlZnQ6IDUsXG4gICAgICAgICAgICB9fVxuICAgICAgICAgICAgb25QcmVzcz17dGhpcy5zaG93VGltZVBpY2tlcn1cbiAgICAgICAgICA+XG4gICAgICAgICAgICA8TGFiZWw+e3RpbWVTdHJpbmd9PC9MYWJlbD5cbiAgICAgICAgICA8L1RvdWNoYWJsZT5cbiAgICAgICAgPC9WaWV3PlxuICAgICAgICA8RGF0ZVRpbWVQaWNrZXJcbiAgICAgICAgICBkYXRlPXtkfVxuICAgICAgICAgIGlzVmlzaWJsZT17aXNUaW1lVmlzaWJsZSB8fCBpc0RhdGVWaXNpYmxlfVxuICAgICAgICAgIG1vZGU9e2lzVGltZVZpc2libGUgPyAndGltZScgOiAnZGF0ZSd9XG4gICAgICAgICAgb25Db25maXJtPXt0aGlzLm9uRGF0ZVBpY2tlZH1cbiAgICAgICAgICBvbkNhbmNlbD17dGhpcy5oaWRlUGlja2VyfVxuICAgICAgICAvPlxuICAgICAgPC9WaWV3PlxuICAgICk7XG4gIH1cbn1cbkRhdGVUeXBlLmRlZmF1bHRQcm9wcyA9IHtcbiAga25vYjoge30sXG4gIG9uQ2hhbmdlOiAodmFsdWUpID0+IHZhbHVlLFxufTtcblxuRGF0ZVR5cGUucHJvcFR5cGVzID0ge1xuICBrbm9iOiBQcm9wVHlwZXMuc2hhcGUoe1xuICAgIG5hbWU6IFByb3BUeXBlcy5zdHJpbmcsXG4gICAgdmFsdWU6IFByb3BUeXBlcy5udW1iZXIsXG4gIH0pLFxuICBvbkNoYW5nZTogUHJvcFR5cGVzLmZ1bmMsXG59O1xuXG5EYXRlVHlwZS5zZXJpYWxpemUgPSAodmFsdWUpID0+IFN0cmluZyh2YWx1ZSk7XG5EYXRlVHlwZS5kZXNlcmlhbGl6ZSA9ICh2YWx1ZSkgPT4gcGFyc2VGbG9hdCh2YWx1ZSk7XG5cbmV4cG9ydCBkZWZhdWx0IERhdGVUeXBlO1xuIl19 */");

var Label =
/*#__PURE__*/
_native["default"].Text(function (_ref2) {
  var theme = _ref2.theme;
  return {
    fontSize: 13,
    color: theme.labelColor
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"); // TODO seconds support


var DateType =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(DateType, _PureComponent);

  function DateType() {
    var _this;

    _classCallCheck(this, DateType);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DateType).call(this));

    _this.showDatePicker = function () {
      _this.setState({
        isDateVisible: true
      });
    };

    _this.showTimePicker = function () {
      _this.setState({
        isTimeVisible: true
      });
    };

    _this.hidePicker = function () {
      _this.setState({
        isDateVisible: false,
        isTimeVisible: false
      });
    };

    _this.onDatePicked = function (date) {
      var value = date.valueOf();
      var onChange = _this.props.onChange;
      onChange(value);

      _this.hidePicker();
    };

    _this.state = {
      isDateVisible: false,
      isTimeVisible: false
    };
    return _this;
  }

  _createClass(DateType, [{
    key: "render",
    value: function render() {
      var knob = this.props.knob;
      var _this$state = this.state,
          isTimeVisible = _this$state.isTimeVisible,
          isDateVisible = _this$state.isDateVisible;
      var d = new Date(knob.value); // https://stackoverflow.com/a/30272803

      var dateString = ["0".concat(d.getDate()).slice(-2), "0".concat(d.getMonth() + 1).slice(-2), d.getFullYear()].join('-');
      var timeString = "".concat("0".concat(d.getHours()).slice(-2), ":").concat("0".concat(d.getMinutes()).slice(-2));
      return _react["default"].createElement(_reactNative.View, {
        style: {
          margin: 10
        }
      }, _react["default"].createElement(_reactNative.View, {
        style: {
          flexDirection: 'row'
        }
      }, _react["default"].createElement(Touchable, {
        onPress: this.showDatePicker
      }, _react["default"].createElement(Label, null, dateString)), _react["default"].createElement(Touchable, {
        style: {
          marginLeft: 5
        },
        onPress: this.showTimePicker
      }, _react["default"].createElement(Label, null, timeString))), _react["default"].createElement(_reactNativeModalDatetimePicker["default"], {
        date: d,
        isVisible: isTimeVisible || isDateVisible,
        mode: isTimeVisible ? 'time' : 'date',
        onConfirm: this.onDatePicked,
        onCancel: this.hidePicker
      }));
    }
  }]);

  return DateType;
}(_react.PureComponent);

DateType.defaultProps = {
  knob: {},
  onChange: function onChange(value) {
    return value;
  }
};
DateType.propTypes = {
  knob: _propTypes["default"].shape({
    name: _propTypes["default"].string,
    value: _propTypes["default"].number
  }),
  onChange: _propTypes["default"].func
};

DateType.serialize = function (value) {
  return String(value);
};

DateType.deserialize = function (value) {
  return parseFloat(value);
};

var _default = DateType;
exports["default"] = _default;